<template>
    <div class="take-job" style="vertical-align: middle;text-align: center">
        <!-- ============= 顶部背景图 ============= -->
        <div>
          <img src="../../assets/images/jobs/banner.png" style="width: 100%;">
        </div>

        <!-- ============= 招聘分类图 ============= -->
        <div  style="height: 280px;width: 100%;text-align: center">
            <ul style="height: 170px;width: 900px;margin: 0 auto;text-align: center">
                <!-- 社会招聘图 -->
                <li style="height: 170px;width: 450px;float: left">
                    <div >
                        <span style="font-size: 24px;">社会招聘</span>
                        <p style="color: rgba(102,102,102,1);">勇者无惧，强者无敌</p>
                        <img src="../../assets/images/jobs/shehuizhaoping.png" >
                    </div>
                </li>

                <!-- 校园招聘图 -->
                <li style="height: 170px;width: 450px;float: left">
                    <div>
                        <div>
                            <span style="font-size: 24px">校园招聘</span>
                            <p style="color: rgba(102,102,102,1);">托起梦想的翅膀，放飞梦想</p>
                        </div>
                        <img  src="../../assets/images/jobs/xiaoyuanzhaopin.png">
                    </div>
                </li>
            </ul>
        </div>

        <!-- 分割模块 -->
        <div style="height: 20px;background-color: rgba(239,245,255,1);"></div>

        <!-- 发展平台介绍 -->
        <div class="develop-platform">
            <h2>优质发展平台</h2>
            <span class="develop-platform-detaile">
              提供全面的学习培养方案，公司员工的职业成长由完善的培训体系和提供技术与管理双通道的晋升机制所提供。中颖在
              不断成长的过程中充满了机遇和挑战，我们每年都着力于在各重点院校招聘优秀的应届毕业生加入中颖电子</span>
        </div>

        <div class="job-table">
            <el-table
              :data="jobList"
              stripe
              :row-click="linkToJobDetaile"
              :header-cell-style="{background:'rgba(239,245,255,1)',color:'#606266'}"
              style="width: 960px;">
              <el-table-column prop="jobName" label="岗位名称" width="360"></el-table-column>
              <el-table-column prop="jobPlace" label="工作地点" width="240"></el-table-column>
              <el-table-column prop="peopleNum" label="招聘人数" ></el-table-column>
              <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
            </el-table>
        </div>

        <div>
            <img src="../../assets/images/jobs/yirenweibenbg.png" style="width: 100%;">
        </div>

        <div class="our-team">
            <h1>我们的团队</h1>
            <span style="color: rgba(102,102,102,1)">我们是一群平凡的人，凝聚在一起，做着不平凡的事</span>

            <div style="margin-top: 40px">
                <ul>
                    <li style="display: inline-block"><img src="../../assets/images/jobs/tu1.png"></li>

                    <li style="display: inline-block;">
                        <ul>
                          <li><img src="../../assets/images/jobs/tu2.png"></li>
                          <li style="margin-top: 8px"><img src="../../assets/images/jobs/tu3.png"></li>
                        </ul>
                    </li>

                    <li style="display: inline-block;">
                        <ul>
                            <li><img src="../../assets/images/jobs/tu4.png"></li>
                            <li style="margin-top: 8px">
                                <ul style="margin: 0;padding: 0;">
                                    <li style="display: inline-block;padding-bottom: 0px"><img src="../../assets/images/jobs/tu5.png"></li>
                                    <li style="display: inline-block;margin-left: 5px;"><img src="../../assets/images/jobs/tu6.png"></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data () {
            return {
                jobList: [],
            }
        },
        mounted:function(){
            this.getJobList();
        },
        methods: {
            linkToJobDetaile:function () {
                this.$router.push({path:'/post'});
                window.location.reload();
            },
            getJobList: function () {
                api.http_mock('/api/getJobList').then(res => {
                    console.log("tableDataTest---->", res);
                    this.jobList = res;
                })
            },
        }
    }
</script>

<style>
  .take-job .job-li { display: inline;float: left }
  .take-job .job-society { position: relative;width: 800px;top: 15%;left: 50% }
  .take-job .job-school { position: relative;width: 800px }
  .take-job .school-title { position: absolute;top:15%;right: 40% }
  .take-job .school-img { position:absolute;display: block;right: 5%;top: 1% }
  .take-job .develop-platform { height: 120px;text-align: center;margin-top: 80px  }
  .take-job .develop-platform-detaile { width: 840px;color: rgba(102,102,102,1);display: block;text-align: center;margin: 0 auto }
  .take-job .job-table { height: 360px;margin-top: 80px;text-align: center;display: inline-block }
  .take-job .our-team { text-align: center;background-color: rgba(246,246,246,1);height: 720px }
</style>



// WEBPACK FOOTER //
// src/pages/jobs/jobs.vue